<ngx-ui-loader
  [loaderId]="'notification-toast'"
  style="height: 100%"
></ngx-ui-loader>
<router-outlet></router-outlet>
